export const LAZY_REGISTRATION_STEP_IDX = 2;



// WEBPACK FOOTER //
// ./pap_v2/constants.js